







import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";
import {formatPrice} from "@/utils/formatters";

@Component({})
export default class ObjektiCard2TabPrometi extends mixins(ComponentBaseMixin) {
  @Prop() turnovers!: [];
  @Prop({default: false}) isBusyLoadingTurnovers!: boolean;

  columns = [];
  options = {
    pagination: true,
    pageSize: 50
  };

  created() {
    this.columns = [
      {field: 'year', title: this.$i18n.t('godina')},
      {field: 'month', title: this.$i18n.t('mesec')},
      {field: 'warehouse', title: this.$i18n.t('distributer')},
      {field: 'product', title: this.$i18n.t('artikal')},
      {field: 'quantity', title: this.$i18n.t('kol'), align: 'right'},
      {field: 'value', title: this.$i18n.t('vrednost'), formatter: value => formatPrice(value), align: 'right'}
    ];
  }

  @Watch('isBusyLoadingTurnovers') isBusyChange(value) {
    let table = $('#turnoversTable');
    if (value) {
      table.bootstrapTable('showLoading');
    } else {
      table.bootstrapTable('hideLoading');
    }
  }
}
